import { purchaseDashboardApi } from "../../api";

const PurchaseDashboardService = {
  /**
   * 📊 Obtiene las estadísticas del dashboard de compras.
   * GET /api/dashboard/purchases/stats
   */
  getStats: async () => {
    try {
      const response = await purchaseDashboardApi.fetchCustom("/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PurchaseDashboardService;
